import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

const Triangle = ({ color, side, topY, bottomY, width, innerY, parentRef, zIndex }) => {
  const canvasRef = useRef(null);

  const [display, setDisplay] = useState('block');

  const verticalOffset = Math.min(topY, innerY);
  const height = Math.max(bottomY, innerY) - verticalOffset;

  const offsetHeight = parentRef && parentRef.current && parentRef.current.offsetHeight;

  useEffect(() => {
    const canvas = canvasRef.current;

    const triangleBottom = Math.max(bottomY, innerY);

    if (parentRef && parentRef.current && triangleBottom > offsetHeight + parentRef.current.offsetTop + 200) {
      setDisplay('none');
      return;
    } else {
      setDisplay('inline');
    }

    const context = canvas.getContext('2d');

    context.fillStyle = color;
    context.beginPath();

    if (side === 'left') {
      context.moveTo(0, topY - verticalOffset);
      context.lineTo(width, innerY - verticalOffset);
      context.lineTo(0, bottomY - verticalOffset);
    } else {
      context.moveTo(width, topY - verticalOffset);
      context.lineTo(width - width, innerY - verticalOffset);
      context.lineTo(width, bottomY - verticalOffset);
    }

    context.closePath();
    context.fill();
  }, [color, side, topY, bottomY, width, innerY, verticalOffset, parentRef, offsetHeight]);

  const styles = {};
  styles['display'] = display;
  styles['position'] = 'absolute';
  styles['top'] = verticalOffset;
  styles['zIndex'] = zIndex;
  if (side === 'left') {
    styles['left'] = 0;
  } else {
    styles['right'] = 0;
  }

  return <canvas className="side-triangle" width={width} height={height} ref={canvasRef} style={styles} />;
};

Triangle.propTypes = {
  color: PropTypes.string,
  side: PropTypes.string,
  topY: PropTypes.number,
  bottomY: PropTypes.number,
  width: PropTypes.number,
  innerY: PropTypes.number,
  zIndex: PropTypes.number,
};

Triangle.defaultProps = {
  color: '#ffb81c',
  side: 'left',
  zIndex: -1,
};

export default Triangle;
